module.exports = __webpack_public_path__ + "media/images/landings/promotion_5/img-campaign-sp@1.5x-7263bcb5c79f4492fc119de6c2aa582c.png";